<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            :title="openData.title"
            :visible.sync="openData.state"
            width="800px"
            class="dialog_container"
            @close="dialogVisibleClose"
        >
            <div class="content">
                <div class="itemContent">
                    <p class="name">姓名：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">餐饮类型：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">取餐方式：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">送餐人员：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent" v-if="openData.title == '查看'">
                    <p class="name">状态：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent" v-if="openData.title == '已送达'">
                    <p class="name">结束时间：</p>
                    <div class="boxs">
                        <el-date-picker
                            v-model="customerBirthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="itemContent" v-if="openData.title == '已送达'">
                    <p class="name">上传图片：</p>
                    <div class="boxs">
                        <el-upload
                            :show-file-list="false"
                            :action="actionUrl"
                            list-type="picture-card"
                            :limit="1"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img
                                v-if="customerPhoto"
                                :src="customerPhoto"
                                class="avatar"
                            />
                            <i
                                v-else
                                class="el-icon-plus avatar-uploader-icon"
                            ></i>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="footer">
                <el-button type="primary" @click="save">发 布</el-button>
                <el-button @click="dialogVisibleClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"
export default {
    props: ["openData"],
    data() {
        return {
            customerPhoto: "",
            customerBirthday: "",
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
        }
    },
    methods: {
        // 上传前
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return
            }
        },
        handleAvatarSuccess(res) {
            this.customerPhoto = res.content
        },
        // 提交
        save() {},
        // 关闭
        dialogVisibleClose() {
            this.$emit("cancleSend", false)
        },
    },
}
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
.itemContent {
    display: flex;
    line-height: 34px;
    margin-bottom: 24px;
    .name {
        width: 120px;
    }
    .boxs {
        flex: 1;
        width: 0;
    }
}
/deep/.avatar-uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
}
</style>